"use client";
import * as stylex from "@stylexjs/stylex";
import { useBlock, useContext } from "timvir/core";
import { layoutStyles } from "../../core/layout";
import { cx } from "../../internal/cx";
/**
 * The underlying DOM element which is rendered by this component.
 */ const Root = "div";
export function Exhibit(props) {
    const { theme: defaultTheme } = useContext().blocks?.Exhibit ?? {};
    const block = useBlock({
        ...props,
        theme: props.theme ?? defaultTheme
    });
    const { caption, bleed, BackdropProps, theme = "system", children, className, style, ...rest } = block.props;
    const rootStyleProps = stylex.props(layoutStyles.block, styles.root);
    const containerStyleProps = stylex.props(styles.container, bleed === 0 && styles.bleedZero, styles[`${theme}Theme`]);
    return <Root data-timvir-b-exhibit {...rest} {...rootStyleProps} className={cx(className, rootStyleProps.className)} style={{
        ...rootStyleProps.style,
        ...style,
        [cssVariables.bleed]: typeof bleed === "number" ? `${bleed}px` : "calc(var(--timvir-margin, 0px) * 0.6666)",
        [cssVariables.borderColor]: "var(--timvir-border-color)",
        [cssVariables.background]: "var(--timvir-background-pattern)"
    }}>
      <div data-timvir-b-exhibit-container {...BackdropProps} {...containerStyleProps} className={cx(containerStyleProps.className, BackdropProps?.className)} style={{
        ...containerStyleProps.style,
        border: bleed === 0 ? "none" : `1px solid var(${cssVariables.borderColor})`,
        ...BackdropProps?.style
    }}>
        {children}
      </div>

      {caption && <div data-timvir-b-exhibit-caption className="x1dcheo9 xjkpybl xvgvpxu xlwy1ot">
          {caption}
        </div>}
    </Root>;
}
const cssVariables = {
    bleed: "--timvir-b-Exhibit-bleed",
    borderColor: "--timvir-b-Exhibit-borderColor",
    background: "--timvir-b-Exhibit-background"
};
const styles = {
    root: {
        $$css: true
    },
    container: {
        k1xSpc: "xufnvkl",
        kKwaWg: "x7zdco",
        kUOVxO: "xzqqpyx",
        kmVPX3: "x1htuw1x",
        kaIpWk: "x1sxf85j",
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "x1tffoc1",
        $$css: true
    },
    bleedZero: {
        ksu8eU: "xng3xce",
        kUOVxO: "xrxpjvj",
        kmVPX3: "x1717udv",
        $$css: true
    },
    systemTheme: {
        kKwaWg: "x7zdco",
        $$css: true
    },
    lightTheme: {
        kKwaWg: "x7ns93p",
        kMwMTN: "x15r2rl4",
        $$css: true
    },
    darkTheme: {
        kKwaWg: "xkt43kk",
        kMwMTN: "xcg6qp",
        $$css: true
    },
    caption: {
        kGuDYH: "x1dcheo9",
        kLWn49: "xjkpybl",
        kMwMTN: "xvgvpxu",
        keoZOQ: "xlwy1ot",
        $$css: true
    }
};
